// Remove /api from base URL since pages add it themselves
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/api$/, '');
